import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PlanAndBilling.module.css';
import {
    getSubscriptionInfo,
    SubscriptionInfo,
} from '../../services/api/subscriptionService';
import Button, { ButtonType } from '../general-components/Button';
import LaunchIcon from '@mui/icons-material/Launch';
import BackgroundContainer from '../ui-components/BackgroundContainer';
import Badge from '../ui-components/Badge';
import LoadingRing from '../ui-components/LoadingRing';

const PlanAndBilling = () => {
    const { t } = useTranslation();
    const [subscriptionInfo, setSubscriptionInfo] =
        useState<SubscriptionInfo>();

    const fetchSubscriptionInfo = async () => {
        const subscriptionInfo = await getSubscriptionInfo();
        setSubscriptionInfo(subscriptionInfo);
    };

    useEffect(() => {
        fetchSubscriptionInfo();
    }, []);

    return (
        <BackgroundContainer>
            {subscriptionInfo && (
                <>
                    <div className={styles.header}>
                        <h3>{t('userPage.planAndBilling.title')}</h3>
                        <Button
                            className={styles.manageSubscriptionButton}
                            type={ButtonType.primary}
                            onClick={() => {
                                window.open(
                                    subscriptionInfo?.portalUrl,
                                    '_blank'
                                );
                            }}
                        >
                            {t(
                                'userPage.planAndBilling.buttons.manageSubscription'
                            )}{' '}
                            <LaunchIcon />
                        </Button>
                    </div>
                    <div className={styles.infoContainer}>
                        <BackgroundContainer>
                            <div className={styles.header}>
                                <h4>
                                    {subscriptionInfo?.variantName}{' '}
                                    {t('userPage.planAndBilling.plan.plan')}
                                </h4>
                                <Badge
                                    color={
                                        subscriptionInfo?.status === 'active' ||
                                        subscriptionInfo?.status === 'trialing'
                                            ? 'green'
                                            : 'red'
                                    }
                                >
                                    {subscriptionInfo?.status}
                                </Badge>
                            </div>

                            <div className={styles.price}>
                                <span>
                                    <h1 style={{ display: 'inline' }}>
                                        ${subscriptionInfo?.variantPrice / 100}
                                    </h1>{' '}
                                    {t('userPage.planAndBilling.price.per')}{' '}
                                    {subscriptionInfo?.variantInterval}
                                </span>
                            </div>
                        </BackgroundContainer>
                        {subscriptionInfo?.status === 'active' && (
                            <BackgroundContainer>
                                {subscriptionInfo?.billingDate && (
                                    <h4>
                                        {t(
                                            'userPage.planAndBilling.plan.renewsAt'
                                        )}
                                    </h4>
                                )}
                                {subscriptionInfo?.endDate && (
                                    <h4>
                                        {t(
                                            'userPage.planAndBilling.plan.endsAt'
                                        )}
                                    </h4>
                                )}
                                <h3>
                                    {subscriptionInfo?.billingDate
                                        ? new Date(
                                              subscriptionInfo.billingDate
                                          ).toLocaleDateString()
                                        : subscriptionInfo?.endDate
                                        ? new Date(
                                              subscriptionInfo.endDate
                                          ).toLocaleDateString()
                                        : ''}
                                </h3>
                            </BackgroundContainer>
                        )}
                    </div>
                </>
            )}
            {subscriptionInfo === undefined && <LoadingRing size="large" />}
        </BackgroundContainer>
    );
};

export default PlanAndBilling;
